export default __webpack_public_path__ + "static/media/avatar-01.980e6101.png";